import { render, staticRenderFns } from "./InquiryInfo.vue?vue&type=template&id=c9a4e8ae&scoped=true"
import script from "./InquiryInfo.vue?vue&type=script&lang=js"
export * from "./InquiryInfo.vue?vue&type=script&lang=js"
import style0 from "./InquiryInfo.vue?vue&type=style&index=0&id=c9a4e8ae&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a4e8ae",
  null
  
)

export default component.exports